module.exports = __webpack_public_path__ + "img/plan.6250e783.svg";